export default __webpack_public_path__ + "static/B43-b066ba1295d7729cc1414a3ab38ad0b5.png";